const brushlessFeaturesJa = {
  // ブラシレスインパクトドリル/レンチ
  product_drill_001_feature_1_title: '180°回転式ハンドル設計',
  product_drill_001_feature_1_desc: '革新的な回転構造により、ピストル型とストレート型をワンタッチで切り替え可能。広い平面から狭い死角まで、あらゆる作業環境に柔軟に対応します。',
  product_drill_001_feature_2_title: 'USB Type-C 急速充電',
  product_drill_001_feature_2_desc: '汎用性の高い Type-C インターフェースを採用。専用充電器は不要で、スマートフォンの充電ケーブルなどでいつでも給電でき、作業の継続性を高めます。',
  product_drill_001_feature_3_title: '高精度トルクとLED照明',
  product_drill_001_feature_3_desc: '4.5Nm の安定したトルクと 250rpm の回転速度を提供。内蔵の LED ワークライトにより、暗所でも精密な組み立て作業が正確に行えます。',
  product_drill_001_feature_4_title: '800Wブラシレス効率',
  product_drill_001_feature_4_desc: '800Wブラシレスモーターでカーボンブラシの摩耗を排除し、より少ない熱でより多くのパワーと長いツール寿命を実現します。',
  product_drill_001_feature_5_title: 'CE/UL/GS三重認証',
  product_drill_001_feature_5_desc: 'CE、UL、GSの3つの安全基準を認証取得し、グローバルな建設市場のプロに信頼されています。',

  product_id_001_feature_1_title: '180°回転式ハンドル設計',
  product_id_001_feature_1_desc: '革新的な回転構造により、ピストル型とストレート型をワンタッチで切り替え可能。広い平面から狭い死角まで、あらゆる作業環境に柔軟に対応します。',
  product_id_001_feature_2_title: 'USB Type-C 急速充電',
  product_id_001_feature_2_desc: '汎用性の高い Type-C インターフェースを採用。専用充電器は不要で、スマートフォンの充電ケーブルなどでいつでも給電でき、作業の継続性を高めます。',
  product_id_001_feature_3_title: '高精度トルクとLED照明',
  product_id_001_feature_3_desc: '4.5Nm の安定したトルクと 250rpm の回転速度を提供。内蔵の LED ワークライトにより、暗所でも精密な組み立て作業が正確に行えます。',
  product_id_001_feature_4_title: '750Wブラシレスモーター',
  product_id_001_feature_4_desc: 'ブラシレス750W設計でワット当たりのトルクが多く、バッテリー寿命を延ばしモーターの熱蓄積を減らします。',
  product_id_001_feature_5_title: '1.72kgバランスインパクト構造',
  product_id_001_feature_5_desc: '1.72kg本体で長時間の頭上・斜めドリル作業のための快適さとのインパクト質量を完璧にバランスします。',

  product_id_002_feature_1_title: '6段階速度調整',
  product_id_002_feature_1_desc: '6段階の速度調整機能を備え、精密な修理から強力な締め付けまで、ニーズに合わせて正確に調整可能です。',
  product_id_002_feature_2_title: 'デュアルモードと高トルク',
  product_id_002_feature_2_desc: '電動モードで 5Nm のトルクを発揮し、手動モードでは最大 8Nm まで対応します。',
  product_id_002_feature_3_title: '360°無影照明',
  product_id_002_feature_3_desc: '3つのLEDワークライトを内蔵。暗い場所での作業でも影を作らず、クリアな視界を確保します。',
  product_id_002_feature_4_title: '800Wピークブラシレス出力',
  product_id_002_feature_4_desc: '800Wモーターで要求の高いドリル作業を処理し、ブラシレス設計でよりクールな長持ちする運転を保証します。',
  product_id_002_feature_5_title: '305mmコンパクトな長さ',
  product_id_002_feature_5_desc: '305mmでこのドリルは壁キャビティや天井空洞などの狭い空間に収まり、多用途な現場での活用を可能にします。',

  product_id_003_feature_1_title: '頂点負荷ブラシレスパワー',
  product_id_003_feature_1_desc: '工業グレードのブラシレスモーターを搭載し、驚異の最大トルク 100Nm を実現。硬質素材への穴あけも容易に行えます。',
  product_id_003_feature_2_title: 'プロ仕様全金属チャック',
  product_id_003_feature_2_desc: '13mm (1/2") 全金属製キーレスチャックを採用。優れた把握力と高い耐久性を誇ります。',
  product_id_003_feature_3_title: '3モード切替と2速制御',
  product_id_003_feature_3_desc: '3機能の金属製インパクトギアボックスを搭載。2速調整が可能で、高速回転と高トルクのニーズを完璧に両立します。',
  product_id_003_feature_4_title: '万能な作業構成',
  product_id_003_feature_4_desc: '最大 26250bpm の打撃数を誇り、LED ワークライトと残量表示を搭載。あらゆる環境下で正確な作業が可能です。',
  product_id_003_feature_5_title: '750W持続インパクトパワー',
  product_id_003_feature_5_desc: '750Wブラシレスモーターで錆付きや過締めのファスナーでも一定のインパクトトルクを維持します。',

  product_id_004_feature_1_title: 'ブラシレスモーターと強力トルク',
  product_id_004_feature_1_desc: '搭载高效无刷电机，提供高达 40Nm 的最大扭矩，轻松应对各种钻孔与紧固任务。',
  product_id_004_feature_2_title: '3モード金属製インパクトギアボックス',
  product_id_004_feature_2_desc: '3機能の金属製インパクトギアボックスを搭載。2速調整が可能で、作業モードを柔軟に切り替えられます。',
  product_id_004_feature_3_title: '精密な制御と便利な設計',
  product_id_004_feature_3_desc: '10mmの金属製チャック、LED作業灯、電源インジケーターを備え、正確な操作を保証します。',
  product_id_004_feature_4_title: '優れた軽量性能',
  product_id_004_feature_4_desc: '本体重量はわずか 0.79kg。高強度の作業でも手への負担を大幅に軽減します。',
  product_id_004_feature_5_title: '750W持続インパクトパワー',
  product_id_004_feature_5_desc: '750Wブラシレスモーターで錆付きや過締めのファスナーでも一定のインパクトトルクを維持します。',

  product_id_005_feature_1_title: 'ブラシレスの高効率パワー',
  product_id_005_feature_1_desc: '先進のブラシレスモーター技術を採用し、60Nmの強力なトルクを提供。作業効率と工具の寿命を大幅に向上させます。',
  product_id_005_feature_2_title: '13mm全金属キーレスチャック',
  product_id_005_feature_2_desc: '10-13mm (3/8"-1/2") の全金属製キーレスチャックを装備。多様なビットに対応し、より強力な締め付けを実現します。',
  product_id_005_feature_3_title: '3モード金属製ギアボックス',
  product_id_005_feature_3_desc: '3機能の金属製インパクトギアボックスと2速調整（最大1800rpm）を搭載。精密な穴あけと強力な打撃を完璧に両立します。',
  product_id_005_feature_4_title: '軽量でバランスの取れた設計',
  product_id_005_feature_4_desc: '本体重量わずか 0.85kg。人間工学に基づいた設計と内蔵LEDライトにより、複雑な環境下でも楽に操作できます。',
  product_id_005_feature_5_title: '60分充電で素早い回転',
  product_id_005_feature_5_desc: '20V 2.0Ahは60分で充電でき、昼食時に充電して午後も続けられます。',

  product_id_006_feature_1_title: 'ブラシレスモーターと強力トルク',
  product_id_006_feature_1_desc: '搭载高效无刷电机，提供高达 40Nm 的最大扭矩，轻松应对各种钻孔与紧固任务。',
  product_id_006_feature_2_title: '3モード金属製インパクトギアボックス',
  product_id_006_feature_2_desc: '3機能の金属製インパクトギアボックスを搭載。2速調整が可能で、作業モードを柔軟に切り替えられます。',
  product_id_006_feature_3_title: '精密な制御と便利な設計',
  product_id_006_feature_3_desc: '10mmの金属製チャック、LED作業灯、電源インジケーターを備え、正確な操作を保証します。',
  product_id_006_feature_4_title: '優れた軽量性能',
  product_id_006_feature_4_desc: '本体重量はわずか 0.79kg。高強度の作業でも手への負担を大幅に軽減します。',
  product_id_006_feature_5_title: '750W持続インパクトパワー',
  product_id_006_feature_5_desc: '750Wブラシレスモーターで錆付きや過締めのファスナーでも一定のインパクトトルクを維持します。',

  product_id_007_feature_1_title: '32mmアニュラーカッターシステム',
  product_id_007_feature_1_desc: '32mmアニュラーカッターヘッドで鋼板、アングルアイアン、構造断面に精密でクリーンな穴をあけます。',
  product_id_007_feature_2_title: '1000Wマグネットドリルパワー',
  product_id_007_feature_2_desc: '1000Wモーターで建設現場の構造鉄骨アニュラー切削に必要な持続トルクを提供します。',
  product_id_007_feature_3_title: '0〜600RPM制御金属切削',
  product_id_007_feature_3_desc: '低い最大600RPM速度でアニュラーカッターの最適パフォーマンスを確保し、切削刃の過熱を防ぎます。',
  product_id_007_feature_4_title: '鉄骨ドリル用4.0Ahバッテリー',
  product_id_007_feature_4_desc: '4.0Ahバッテリーでパワー低下なく長い構造鉄骨ドリル作業をサポートします。',
  product_id_007_feature_5_title: '3.20kg重型鉄骨ドリル本体',
  product_id_007_feature_5_desc: '3.20kgの重型本体で構造鉄骨穴あけ時にアニュラーカッターを軸に沿って保つ安定性を提供します。',

  product_id_008_feature_1_title: '82mmコアドリルシステム',
  product_id_008_feature_1_desc: '82mmコアビットシステムでパイプや配線管用にコンクリート壁、床、構造スラブに大径穴をあけます。',
  product_id_008_feature_2_title: '900Wコア切削モーター',
  product_id_008_feature_2_desc: '900Wで周辺構造を損傷することなく鉄筋コンクリートを貫通し、クリーンで丸い穴を作ります。',
  product_id_008_feature_3_title: '0〜800RPMコアドリル速度',
  product_id_008_feature_3_desc: '800RPMの最大速度でコアビットの寿命を確保し、厚いコンクリートスラブを切削する際のクリーンな切削を維持します。',
  product_id_008_feature_4_title: '2.50kg安定コアドリル',
  product_id_008_feature_4_desc: '2.50kg本体で鉄筋スラブを切削する際にコアビットを位置合わせするための質量とバランスを提供します。',
  product_id_008_feature_5_title: '完全コンクリート作業用4.0Ah',
  product_id_008_feature_5_desc: '4.0Ahバッテリーで効率的なスラブ貫通作業のために1回の充電で複数の82mmコンクリート穴を貫通できます。',

  product_id_009_feature_1_title: '重材料用パドルミキサー',
  product_id_009_feature_1_desc: 'パドルアタッチメントで最大30kgのバケツ内のコンクリート、モルタル、グラウト、接着剤を力なく混合します。',
  product_id_009_feature_2_title: '850W混合モーター',
  product_id_009_feature_2_desc: '850Wモーターで厚くて重い材料でも詰まりや過熱なく一定の混合速度を維持します。',
  product_id_009_feature_3_title: '0〜700RPM制御混合速度',
  product_id_009_feature_3_desc: '可変最大700RPMで混合速度をスプラッシュしきい値以下に保ち、制御されたクリーンな現場混合を実現します。',
  product_id_009_feature_4_title: '両手制御用Dハンドル',
  product_id_009_feature_4_desc: 'Dハンドルグリップで大きなバケツ内の重い材料を混合する際の安全な両手制御が可能です。',
  product_id_009_feature_5_title: '長時間混合セッション用4.0Ah',
  product_id_009_feature_5_desc: '4.0Ahパックで現場全体の混合サイクルを通じてパドル混合の高電流需要を持続します。',

  // ブラシレスインパクトドライバー
  product_idr_001_feature_1_title: '圧倒的なインパクトパワー',
  product_idr_001_feature_1_desc: '高効率ブラシレスモーターを搭載。160Nm の圧倒的なトルクで、長ネジの打ち込みや高強度の締め付け作業も容易にこなします。',
  product_idr_001_feature_2_title: '3段階の精密トルク調整',
  product_idr_001_feature_2_desc: '3段階の調整可能なトルク（40/130/160 Nm）と3段階の速度調整機能を備え、様々な素材に対して精密な作業を実現します。',
  product_idr_001_feature_3_title: 'クイック装着設計',
  product_idr_001_feature_3_desc: ' 6.35mm (1/4") クイック装着チャックを採用。片手で素早くビット交換が可能で、作業効率を大幅に向上させます。',
  product_idr_001_feature_4_title: '軽量で優れたバランス設計',
  product_idr_001_feature_4_desc: 'わずか 0.79kg の超軽量設計とコンパクトなボディにより、狭い場所や高所での作業でも自由自在に操作できます。',
  product_idr_001_feature_5_title: '700Wブラシレスインパクトモーター',
  product_idr_001_feature_5_desc: '700Wブラシレスモーターで終日使用中のバッテリー効率を最大化しながら毎ショット高インパクトエネルギーを発揮します。',

  product_idr_002_feature_1_title: '強力なインパクトパワー',
  product_idr_002_feature_1_desc: '最大トルク 150Nm を発揮し、建築や木工作業における高負荷の締め付けタスクも容易にこなします。',
  product_idr_002_feature_2_title: '高速な作業パフォーマン',
  product_idr_002_feature_2_desc: '3000 rpm の高速回転と 3200 bpm の打撃数により、長ネジの打ち込み時間を大幅に短縮します。',
  product_idr_002_feature_3_title: 'クイック装着ビットシ',
  product_idr_002_feature_3_desc: '6.35mm (1/4") クイック装着チャックを搭載。片手で素早くビット交換ができ、マルチタスクの効率を高めます。',
  product_idr_002_feature_4_title: '人間工学に基づいた作業補助',
  product_idr_002_feature_4_desc: 'わずか 0.79kg の軽量コンパクトなボディに LED ワークライトを内蔵。狭い場所や暗い環境でも楽に操作できます。',
  product_idr_002_feature_5_title: '680W効率的ドライブパワー',
  product_idr_002_feature_5_desc: '680W効率的ブラシレスモーターでバッテリーランタイムを最大化し、毎充電でより多くのビスを打ち込みます。',

  product_idr_003_feature_1_title: 'フラッグシップ級の工業パワー',
  product_idr_003_feature_1_desc: '高性能ブラシレスモーターを搭載し、最大 280Nm の圧倒的なトルクを実現。超高強度の締め付けや重作業に最適です。',
  product_idr_003_feature_2_title: '3段階インテリジェントトルク調整',
  product_idr_003_feature_2_desc: '3段階の調整可能なトルク（130/200/280 Nm）と3段階の速度調整機能を備え、素材に合わせた精密なコントロールが可能です。',
  product_idr_003_feature_3_title: '極限の作業効率',
  product_idr_003_feature_3_desc: '最大 3200bpm の打撃数と 2650rpm の高速回転を誇り、クイック装着チャックとの組み合わせで極めてスピーディーな作業を実現します。',
  product_idr_003_feature_4_title: 'コンパクトな強力構造',
  product_idr_003_feature_4_desc: 'わずか 1.2kg のボディで優れたパワーウェイトレシオを実現。LED ライトを内蔵し、複雑な環境でも正確な操作をサポートします。',
  product_idr_003_feature_5_title: 'マルチモードトルク選択',
  product_idr_003_feature_5_desc: 'マルチトルクモード設定で異なる材料に合わせて組立、固定、構造モードを切り替えられます。',

  product_idr_004_feature_1_title: '圧倒的な工業用トルク',
  product_idr_004_feature_1_desc: '高性能ブラシレスモーターを搭載し、最大 500Nm の超強力トルクを実現。重機メンテナンスや自動車整備に最適です。',
  product_idr_004_feature_2_title: 'プロ仕様 1/2" スクエアドライブ',
  product_idr_004_feature_2_desc: '12.7mm (1/2") プロ仕様スクエアドライブを採用。ソケットを確実に保持し、高強度の打撃でも優れた耐久性を発揮します。',
  product_idr_004_feature_3_title: '反転オートストップ機能',
  product_idr_004_feature_3_desc: '反転オートストップ機能を搭載。ナットの取り外し時に、慣性による脱落や破損を効果的に防ぎます。',
  product_idr_004_feature_4_title: '3段階打撃と2速制御',
  product_idr_004_feature_4_desc: '最大 3200bpm の打撃数と2速調整（最大 2650rpm）により、あらゆる作業条件に柔軟に対応します。',
  product_idr_004_feature_5_title: '優れた軽量構造',
  product_idr_004_feature_5_desc: '本体重量わずか 1.2kg。高出力と優れた操作性を両立し、長時間の作業でも疲労を大幅に軽減します。',

  product_idr_005_feature_1_title: '圧倒的な工業用トルク',
  product_idr_005_feature_1_desc: '最高性能のブラシレスモーターを搭載し、驚異の 850Nm トルクを発揮。大型建設、重機、トラックの整備など、極限の締め付け作業に最適です。',
  product_idr_005_feature_2_title: 'プロ仕様 1/2" 重負荷用スクエアドライブ',
  product_idr_005_feature_2_desc: '12.7mm (1/2") 工業用スクエアドライブを採用。高頻度の打撃下でも安定した耐久性を誇り、ソケットを確実に保持します。',
  product_idr_005_feature_3_title: '反転オートストップ保護機能',
  product_idr_005_feature_3_desc: 'インテリジェントな反転オートストップ機能を搭載。ナットが緩んだ直後に回転を停止し、ナットの脱落や作業面の損傷を効果的に防ぎます。',
  product_idr_005_feature_4_title: '多段階インテリジェント速度制御',
  product_idr_005_feature_4_desc: '3段階の打撃数（最大 2200bpm）と3段階の速度調整（最大 2400rpm）に対応。過酷な作業現場に合わせて精密な調整が可能です。',
  product_idr_005_feature_5_title: '全天候型作業性能',
  product_idr_005_feature_5_desc: 'LED ワークライトを内蔵し暗所での視界を確保。1.9kg の堅牢なボディにより、安定したパワーと長寿命を実現します。',

  product_idr_006_feature_1_title: '直角165N·mインパクトドライバー',
  product_idr_006_feature_1_desc: '直角ヘッドが狭い空間で165N·mのインパクトトルクを発揮し、パネル裏やキャビネット内のファスナーに届きます。',
  product_idr_006_feature_2_title: '0〜2800RPM直角ドライブ',
  product_idr_006_feature_2_desc: '直角構成で2800RPMに可変速度、壁フレーミング、床、狭いベイを通じてビスを打ちます。',
  product_idr_006_feature_3_title: '258mm直角長さ',
  product_idr_006_feature_3_desc: '258mm直角本体でスタッドベイやキャビネット内部など標準インラインインパクトドライバーがアクセスできない場所に入ります。',
  product_idr_006_feature_4_title: '690W直角モーター',
  product_idr_006_feature_4_desc: '直角形式の690Wブラシレスモーターで配管、電気、フレーミング作業に安定したトルクを提供します。',
  product_idr_006_feature_5_title: '多角度アクセス用スイベルヘッド',
  product_idr_006_feature_5_desc: '回転ヘッドが複数の角度でロックし、真っ直ぐなドライバーが届かない位置のファスナーへのアクセスを提供します。',

  product_idr_007_feature_1_title: '180N·m延長ボディドライバー',
  product_idr_007_feature_1_desc: '深い凹みや長いランのファスナーに届く延長ボディ構成の180N·mインパクトドライバー。',
  product_idr_007_feature_2_title: '0〜3200RPM延長リーチドライブ',
  product_idr_007_feature_2_desc: '245mm延長本体でのフル3200RPM、深い材料スタックへの長いビスを速度と精度で打ち込みます。',
  product_idr_007_feature_3_title: '245mm延長長さプロファイル',
  product_idr_007_feature_3_desc: '長い245mm本体で高い足場ボード、深いフレーム、アクセスしにくい構造ポイントのファスナーに届きます。',
  product_idr_007_feature_4_title: '1.50kg安定ドライブ重量',
  product_idr_007_feature_4_desc: '1.50kgバランス重量で現場の延長位置への到達時のドライブ精度維持を助けます。',
  product_idr_007_feature_5_title: '700W長距離ブラシレスモーター',
  product_idr_007_feature_5_desc: 'ブラシレス700Wモーターで有刷設計の熱蓄積なく延長長さのビス打ちを処理します。',

  product_idr_008_feature_1_title: '185N·mコンパクトプロドライバー',
  product_idr_008_feature_1_desc: 'コンパクト172mm本体に185N·mのインパクトトルク、プロアプリケーションでの最小サイズに最大トルク。',
  product_idr_008_feature_2_title: '0〜3300RPM近最大速度',
  product_idr_008_feature_2_desc: '3300RPM近最大速度が高出力トルクと速度を組み合わせ、最速のプロスクリュードライブを実現します。',
  product_idr_008_feature_3_title: '1.35kg高トルクコンパクト',
  product_idr_008_feature_3_desc: '1.35kgパッケージに185N·m、インパクトドライバーシリーズで最高のパワーウェイトレシオです。',
  product_idr_008_feature_4_title: '710W高密度ブラシレスモーター',
  product_idr_008_feature_4_desc: 'コンパクトハウジングに高密度パックされた710Wモーターが驚くほど小さなツールで際立ったパフォーマンスを発揮します。',
  product_idr_008_feature_5_title: 'クイックチェンジ六角シャンクシステム',
  product_idr_008_feature_5_desc: 'マグネットクイックチェンジチャックでカラーを緩めずに瞬時にビット交換、マルチファスナー作業を大幅に高速化します。',

  product_idr_009_feature_1_title: '170N·mスムーズ静音ドライバー',
  product_idr_009_feature_1_desc: '170N·mインパクトトルクでシリーズ最低ノイズ≦80dB、屋内仕上げ作業や住宅現場に最適です。',
  product_idr_009_feature_2_title: '超静音80dB動作',
  product_idr_009_feature_2_desc: 'クラス最高の≦80dBノイズレベルで内装仕上げ環境、アパート、騒音に敏感な作業条件に対応します。',
  product_idr_009_feature_3_title: '0〜3000RPM静音可変速',
  product_idr_009_feature_3_desc: '最小ノイズ出力を維持しながらフル3000RPM可変速度、内装仕上げ用途への静かなパワー。',
  product_idr_009_feature_4_title: '680W低ノイズブラシレスモーター',
  product_idr_009_feature_4_desc: 'ブラシレスモーター設計が本質的に有刷の代替品よりも少ないノイズと振動を生成し、静かな作業を実現します。',
  product_idr_009_feature_5_title: '繊細な固定のためのソフトスタート',
  product_idr_009_feature_5_desc: 'ソフトスタート機能で小さなビスや繊細な表面へのビット滑りを防ぎ、仕上げ大工やキャビネット作業に最適です。',

  product_idr_010_feature_1_title: '220N·m最大トルクドライバー',
  product_idr_010_feature_1_desc: '220N·mはインパクトドライバーシリーズ最高トルクで、最大の構造六角ボルトや木ボルトを処理します。',
  product_idr_010_feature_2_title: '0〜3500RPMトップスピードドライバー',
  product_idr_010_feature_2_desc: '最大3500RPMと220N·mの組み合わせで構造作業向けの比類ないスピードとトルクを提供します。',
  product_idr_010_feature_3_title: '重型固定用4.0Ahバッテリー',
  product_idr_010_feature_3_desc: '4.0Ahバッテリーで1回の充電で何百もの構造六角ボルトサイクルをサポートし、拡張フレーミングセッションに対応します。',
  product_idr_010_feature_4_title: '800W高出力ブラシレスモーター',
  product_idr_010_feature_4_desc: '800Wブラシレスモーターはドライバーラインで最大パワーで、繰り返しの六角ボルト打ちでピークトルクを維持します。',
  product_idr_010_feature_5_title: '4.0Ahで55分急速充電',
  product_idr_010_feature_5_desc: '大容量4.0Ahバッテリーでもわずか55分で満充電でき、構造作業を継続できます。',

  // ブラシレスアングルグラインダー
  product_ag_001_feature_1_title: '高性能ブラシレス動力システム',
  product_ag_001_feature_1_desc: '次世代ブラシレスモーターを搭載し、8500 rpm の安定した高速回転を提供。ブラシモーターと比較してエネルギー消費を30%削減、寿命を2倍に延ばし、連続した重負荷切断でもパワーを維持します。',
  product_ag_001_feature_2_title: 'ユニバーサルディスクとネジ規格の互換性',
  product_ag_001_feature_2_desc: 'Ø100-125mm の多様なディスクに対応し、M10-M14 および 5/8"-11UNC の国際標準ネジ規格をサポート。アダプターなしで市販の主要な消耗品をそのまま使用できます。',
  product_ag_001_feature_3_title: '精密な深さ調節と工業用保護',
  product_ag_001_feature_3_desc: '0-25mm の切断深さ調整機能を備え、高強度の厚型メタル安全カバーを装備。精密な作業深度を実現しながら、最高レベルの飛散防止保護を提供します。',
  product_ag_001_feature_4_title: '極限のバランスと人間工学設計',
  product_ag_001_feature_4_desc: '1.5kg の超軽量ボディは重心バランスを最適化。長時間の作業でも手首の疲労を大幅に軽減し、スリムなハンドル設計がより確実なホールド感を提供します。',
  product_ag_001_feature_5_title: 'キックバック防止過負荷保護',
  product_ag_001_feature_5_desc: '電子過負荷保護でピンチングを検出しディスクをシャットオフ、金属作業中の危険なキックバックを防ぎます。',

  product_ag_002_feature_1_title: '125mm標準グラインダーディスク',
  product_ag_002_feature_1_desc: '125mmディスクは最も広く入手可能なサイズで、多数の研削、切断、サンディングディスクと互換性があります。',
  product_ag_002_feature_2_title: '8500RPMプロ研削速度',
  product_ag_002_feature_2_desc: '8500RPMは125mmディスクに最適な研削速度で、材料除去率とディスク寿命のバランスを取ります。',
  product_ag_002_feature_3_title: '900W高出力モーター',
  product_ag_002_feature_3_desc: '900Wモーターで構造鉄骨での長時間研削セッションに対して過熱や切断速度の低下なく処理します。',
  product_ag_002_feature_4_title: '4.0Ah持続パワーパック',
  product_ag_002_feature_4_desc: '4.0Ahバッテリーで小容量パックの頻繁なバッテリー交換なく長い研削・切断作業を継続できます。',
  product_ag_002_feature_5_title: '調整可能サイドハンドル',
  product_ag_002_feature_5_desc: '位置変更可能なサイドハンドルで全ての研削姿勢に対して快適なコントロールのための最適なグリップ角度を設定できます。',

  product_ag_003_feature_1_title: '150mm重型グラインダー',
  product_ag_003_feature_1_desc: 'より大きな150mmディスクで広い研削表面積を提供し、平坦な溶接や大型鋼断面への速い材料除去を実現します。',
  product_ag_003_feature_2_title: '8000RPM制御大ディスク速度',
  product_ag_003_feature_2_desc: '8000RPMは150mmディスクサイズに最適化され、安全な周速を維持しながら研削パワーを最大化します。',
  product_ag_003_feature_3_title: '1000W最大パワーモーター',
  product_ag_003_feature_3_desc: '1000Wモーターはグラインダーシリーズ最大で、重型鋼板や厚い溶接を貫通して150mmディスクを駆動します。',
  product_ag_003_feature_4_title: '2.10kgグラインダーバランス重量',
  product_ag_003_feature_4_desc: '2.10kg本体で大きな平坦な研削表面への安定したディスク接触を維持するための質量を提供します。',
  product_ag_003_feature_5_title: '振動吸収サイドハンドル',
  product_ag_003_feature_5_desc: '振動減衰サイドハンドルで研削疲労を軽減し、重型素材除去作業のコントロール精度を向上します。',

  product_ag_004_feature_1_title: '125mm可変速グラインダー',
  product_ag_004_feature_1_desc: '4500〜9500RPMの可変速度でディスク変更なしに同じツールで激しい研削や丁寧な仕上げが可能です。',
  product_ag_004_feature_2_title: '4500〜9500RPMスピードダイヤル',
  product_ag_004_feature_2_desc: 'スピードダイヤルでディスク速度を材料に正確に合わせ、ステンレス磨きには遅く、炭素鋼研削には速く設定できます。',
  product_ag_004_feature_3_title: '可変速ブラシレスモーター',
  product_ag_004_feature_3_desc: 'ブラシレスモーター電子機器で変化する負荷の下でも設定速度を維持し、材料全体で一定の表面仕上げを実現します。',
  product_ag_004_feature_4_title: '研削ディスク用ソフトスタート',
  product_ag_004_feature_4_desc: 'ソフトスタートで研削ディスクの起動時の衝撃負荷を防ぎ、ディスク寿命を延ばしグラインダーの耐久性を向上します。',
  product_ag_004_feature_5_title: '可変速作業用4.0Ahバッテリー',
  product_ag_004_feature_5_desc: '4.0Ahパックでバッテリー交換なく研削、切断、磨きの長い可変速セッションをサポートします。',

  product_ag_005_feature_1_title: '125mmステンレス鋼グラインダー',
  product_ag_005_feature_1_desc: '125mmステンレス鋼研削・仕上げに最適化され、材料を汚染することなくクリーンな表面を提供します。',
  product_ag_005_feature_2_title: '8500RPMステンレス安全速度',
  product_ag_005_feature_2_desc: '8500RPMと制御されたパワー供給で熱に敏感なステンレス鋼研削時の過熱防止を実現します。',
  product_ag_005_feature_3_title: '900W安定ステンレスパフォーマンス',
  product_ag_005_feature_3_desc: '900W持続モーター出力でステンレス鋼板の全厚さにわたって一定の研削速度を維持します。',
  product_ag_005_feature_4_title: '汚染防止設計',
  product_ag_005_feature_4_desc: '内部部品がステンレス鋼粒子に対してシールされ、モーターとベアリングへの汚染を防ぎます。',
  product_ag_005_feature_5_title: 'クイックチェンジガードシステム',
  product_ag_005_feature_5_desc: 'ツール不要のガード調整で研削、切断、磨きディスク構成の迅速な位置変更が可能です。',

  product_ag_006_feature_1_title: '125mmアルミ磨きグラインダー',
  product_ag_006_feature_1_desc: '125mmアルミニウム研削・磨きに調整され、柔らかいアルミニウム材料を延ばさずに表面品質を維持します。',
  product_ag_006_feature_2_title: '8500RPMアルミ最適化速度',
  product_ag_006_feature_2_desc: '8500RPMはアルミサンディングディスクに理想的な速度で、ディスクへの材料蓄積なくスムーズな仕上げを提供します。',
  product_ag_006_feature_3_title: '91dB低ノイズプロファイル',
  product_ag_006_feature_3_desc: '≦91dBで動作し、ほとんどの125mmグラインダーより静かで、騒音基準が厳しいワークショップに適しています。',
  product_ag_006_feature_4_title: '900Wアルミドライブモーター',
  product_ag_006_feature_4_desc: '900Wモーターでワークピースを軟化させる過熱を生成せずに効率的にアルミニウムを研削します。',
  product_ag_006_feature_5_title: '1.88kgバランスプロファイル',
  product_ag_006_feature_5_desc: '1.88kgは生のパワーよりも精度が重要な制御されたアルミニウム表面仕上げのための理想的な質量を提供します。',

  product_ag_007_feature_1_title: '125mmタイル切断グラインダー',
  product_ag_007_feature_1_desc: '125mmダイヤモンド切断のセラミックタイル、磁器、石材にチップのないクリーンなエッジ品質で対応します。',
  product_ag_007_feature_2_title: '8500RPMタイル切断速度',
  product_ag_007_feature_2_desc: '8500RPMで効率的なダイヤモンドブレードタイル切断に必要な周速を提供し、エッジのチッピングなく実現します。',
  product_ag_007_feature_3_title: '900W持続切断パワー',
  product_ag_007_feature_3_desc: '900W持続モーターでより劣るグラインダーを詰まらせる厚い磁器タイルを通じて切断速度を維持します。',
  product_ag_007_feature_4_title: '1.92kg安定タイル切断重量',
  product_ag_007_feature_4_desc: '1.92kg本体でガイドされたタイルカットの安定性を提供し、マーキングラインに沿った直線で正確な切断に不可欠です。',
  product_ag_007_feature_5_title: 'タイル粉塵用防塵シールモーター',
  product_ag_007_feature_5_desc: 'シールされたモーター内部がタイル切断粉塵に対抗し、粉塵の多い石材・タイル材の切断時のツール寿命を延ばします。',

  product_ag_008_feature_1_title: '125mmコンクリート切断グラインダー',
  product_ag_008_feature_1_desc: '125mmコンクリート切断・表面研削のために設計され、レイタンス、高い箇所、継ぎ目シーラントを精密に除去します。',
  product_ag_008_feature_2_title: '8500RPMコンクリートディスク速度',
  product_ag_008_feature_2_desc: '8500RPMは125mmコンクリート切断・表面処理ホイールに最適なディスク速度を提供します。',
  product_ag_008_feature_3_title: '900Wコンクリートグレードパワー',
  product_ag_008_feature_3_desc: '900Wで緻密なコンクリート断面の切断と厚い表面コーティングの除去時に研削速度を維持します。',
  product_ag_008_feature_4_title: '92dB高需要ノイズレベル',
  product_ag_008_feature_4_desc: '≦92dBノイズレベルはコンクリートグラインダーの典型的な値で、現場のルールに従って耳の保護具を着用してください。',
  product_ag_008_feature_5_title: 'スラブ作業用4.0Ah',
  product_ag_008_feature_5_desc: '4.0Ahバッテリーで充電前に大型スラブ断面のコンクリート研削を維持できます。',

  product_ag_009_feature_1_title: '125mm可変速ポリッシャー',
  product_ag_009_feature_1_desc: '125mmポリッシングパッド用の可変5000〜8500RPM、渦のない塗装修正とディテーリングの精密速度コントロール。',
  product_ag_009_feature_2_title: '5000〜8500RPMポリッシング速度範囲',
  product_ag_009_feature_2_desc: '5000RPMから始まる低い速度範囲で車のボディワークのポリッシング時の塗装や透明コートの焼き付きを防ぎます。',
  product_ag_009_feature_3_title: '800Wブラシレスポリッシュモーター',
  product_ag_009_feature_3_desc: '800Wブラシレスモーターでポリッシングパッドの圧力下でも一定速度を維持し、均一な仕上げ品質を保証します。',
  product_ag_009_feature_4_title: '1.85kgポリッシングバランス',
  product_ag_009_feature_4_desc: '1.85kgポリッシャー重量で強く押しすぎることなく塗装修正のための適切な接触圧力を提供します。',
  product_ag_009_feature_5_title: '電子速度安定化',
  product_ag_009_feature_5_desc: '電子ガバナーでパッドの抵抗下のディスク速度を安定させ、パネル全体で一定の表面仕上げを維持します。',

  product_ag_010_feature_1_title: '125mmプロ製造グラインダー',
  product_ag_010_feature_1_desc: '金属加工のプレミアム125mmグラインダーで研削、切断、ワイヤーブラッシング、表面処理を同等にこなします。',
  product_ag_010_feature_2_title: '8500RPMフルパフォーマンス速度',
  product_ag_010_feature_2_desc: 'すべてのディスクタイプで8500RPMの一定速度で製造工場環境向けの一貫したプロパフォーマンスを発揮します。',
  product_ag_010_feature_3_title: '900W製造グレードモーター',
  product_ag_010_feature_3_desc: '900Wブラシレスモーターが積極的な溶接研削から精細な表面仕上げまで製造作業の多様な需要を処理します。',
  product_ag_010_feature_4_title: '2.00kgバランス製造重量',
  product_ag_010_feature_4_desc: '2.00kgで制御された精密作業と重型素材除去に必要な質量の理想的なバランスを取ります。',
  product_ag_010_feature_5_title: '電子過負荷保護',
  product_ag_010_feature_5_desc: '電子保護でモーター負荷を監視しパワーを調整することで、集中使用時の詰まりと熱過負荷を防ぎます。',
  // ===== ブラシレスツールアクセサリー翻訳 =====

  // ブラシレスドリル/インパクトレンチ配件（ドリル類、共用）
  // brushless_drill_acc_1_name: '数据线',
  // brushless_drill_acc_1_desc: 'TyepCC数据线',
  // brushless_drill_acc_2_name: '急速充電器',
  // brushless_drill_acc_2_desc: '4Ahバッテリーを55分で満充電、昼休みに充電して午後も全力作業を継続、ダウンタイム最小化',
  // brushless_drill_acc_3_name: 'HSSドリルビットセット',
  // brushless_drill_acc_3_desc: '1〜13mm全19本HSS鉄鋼ドリルビットセット、木材・金属・プラスチック対応で日常的なドリル作業をすべてカバー',
  // brushless_drill_acc_4_name: '石工アンカービットセット',
  // brushless_drill_acc_4_desc: '6/8/10/12mm SDS+またはストレートシャンク石工ビットセット、ハンマーモードでの壁アンカードリル向けに最適化',
  // brushless_drill_acc_5_name: 'ツール収納ケース',
  // brushless_drill_acc_5_desc: 'ドリル・バッテリー・配件専用フォームライニングハードシェルケース、現場での安全な保管と持ち運びに対応',
  // brushless_drill_acc_6_name: '安全ゴーグル',
  // brushless_drill_acc_6_desc: '透明防曇レンズ安全ゴーグル、ドリル作業中に飛散するコンクリート破片や金属切屑から目を保護',
  // brushless_drill_acc_7_name: 'クリーニング＆メンテナンスキット',
  // brushless_drill_acc_7_desc: 'クリーニングブラシ・グリース・拭き布を含む総合メンテナンスキット、チャックをスムーズに保ちツール寿命を延長',
  // brushless_drill_acc_8_name: 'サイドハンドル',
  // brushless_drill_acc_8_desc: '調整可能サイドハンドルで高トルク作業時の両手安定制御を実現、キックバックリスク低減とドリル精度向上',

  // ブラシレスインパクトドライバー配件（idr類、共用）
  // brushless_idr_acc_1_name: '20V 4Ahリチウムバッテリー',
  // brushless_idr_acc_1_desc: '大容量20V 4Ahバッテリーで終日の構造固定作業に対応、1回の充電で何百本もスクリューを打ち込める',
  // brushless_idr_acc_2_name: '急速充電器',
  // brushless_idr_acc_2_desc: '55分急速充電で4Ahバッテリーを素早く補充、ヘビーな工事セッション中でも最小限の待ち時間で作業継続',
  // brushless_idr_acc_3_name: 'インパクトドライバービットセット',
  // brushless_idr_acc_3_desc: '25本インパクト対応ドライバービットセット、プラス・トルクス・マイナス・六角各種対応で標準ビットより高い鋼材硬度',
  // brushless_idr_acc_4_name: 'マグネット式ビット延長バー',
  // brushless_idr_acc_4_desc: '60/150mmマグネット六角延長バーで狭い場所のファスナーに届き、マグネット保持でビット落下を防止',
  // brushless_idr_acc_5_name: 'ツールキャンバスバッグ',
  // brushless_idr_acc_5_desc: 'インパクトドライバー・バッテリー・ビット用コンパートメント付きキャンバスバッグ、複数現場への移動に最適な軽量設計',
  // brushless_idr_acc_6_name: '耐切創作業グローブ',
  // brushless_idr_acc_6_desc: '耐磨耗高強力作業グローブで集中的な固定作業中に手を保護、インパクトドライバーのトリガー感覚を維持',
  // brushless_idr_acc_7_name: 'ベルトフッククリップ',
  // brushless_idr_acc_7_desc: '頑丈なベルトクリップでインパクトドライバーを腰に吊り下げ、即座のアクセスを可能にし工具取りに往復不要',
  // brushless_idr_acc_8_name: 'ビットホルダーセット',
  // brushless_idr_acc_8_desc: 'マグネット式ビットホルダーラックで複数の頻用ビットを準備待機、バッグを探さず現場で素早くビット交換',

  // ブラシレスアングルグラインダー配件（ag類、共用）
  // brushless_ag_acc_1_name: '20V 4Ahリチウムバッテリー',
  // brushless_ag_acc_1_desc: '大容量20V 4Ahバッテリーで連続金属研削・切断の高エネルギー需要に対応、作業中途のバッテリー交換回数を削減',
  // brushless_ag_acc_2_name: '急速充電器',
  // brushless_ag_acc_2_desc: '4Ahバッテリーを55分で急速充電、長時間研削セッション中の短い休憩でフルパワーを回復',
  // brushless_ag_acc_3_name: '金属研削ディスクセット',
  // brushless_ag_acc_3_desc: '125mm酸化アルミニウム研削ディスク5枚セット、36/60/80番対応、溶接研削・錆除去・金属整形を1セットでカバー',
  // brushless_ag_acc_4_name: 'ダイヤモンド切断ブレード',
  // brushless_ag_acc_4_desc: '125mmドライ/ウェット兼用ダイヤモンド切断ブレード、コンクリート・レンガ・タイルへのクリーンな切断、標準砥石より大幅に長い耐用年数',
  // brushless_ag_acc_5_name: '安全フェイスシールド',
  // brushless_ag_acc_5_desc: '全面透明保護シールドで研削・切断作業時の金属破片と火花飛散を防御、安全ゴーグルとの併用を推奨',
  // brushless_ag_acc_6_name: '防振作業グローブ',
  // brushless_ag_acc_6_desc: 'シリコン防振パームグローブで研削作業の長時間振動伝達を軽減、手の関節を保護しグリップ快適性を向上',
  // brushless_ag_acc_7_name: 'ディスクフランジ＆レンチキット',
  // brushless_ag_acc_7_desc: '内外フランジセットとピンスパナによる安全な研削・切断ディスク交換キット、必要なハードウェアが一式揃う',
  // brushless_ag_acc_8_name: 'ツールキャンバスキャリーバッグ',
  // brushless_ag_acc_8_desc: 'アングルグラインダー・バッテリー・頻用ディスクをまとめて収納する耐久キャンバスバッグ、防塵・衝撃保護で現場作業に対応',
  A: 'ri文型号',
  B: 'ri我是电池',
};

export default brushlessFeaturesJa;
